import type { OnboardingItemKey } from './__generated__/navRefreshOptOutQuery.graphql';

export const NAV_REFRESH_OPT_OUT_KEY: OnboardingItemKey = 'NAV_REFRESH_OPT_OUT';
